module.exports = __webpack_public_path__ + "static/img/360_1.8454f856.png";